import { FleetUser } from "../models/FleetUser";

export class UpdateFleetUserResponse {
    fleetUser?: FleetUser;
}